import { createSlice } from '@reduxjs/toolkit'
import { Payload, ReduxRootState } from 'types'

import { Approval } from '../../../../redux-store/models'

interface ApprovalState {
  practiceId: string | null
  currentApproval: null | Approval
  isCurrentApprovalLoading: boolean
}

const initialState: ApprovalState = {
  practiceId: null,
  currentApproval: null,
  isCurrentApprovalLoading: true,
}

export const approvalSlice = createSlice({
  name: 'approval',
  initialState,
  reducers: {
    setPracticeId: (state, { payload }: Payload<string | null>) => {
      state.practiceId = payload
    },
    setCurrentApproval: (state, { payload }: Payload<null | Approval>) => {
      state.currentApproval = payload
    },
    setCurrentApprovalLoading: (state, { payload }: Payload<boolean>) => {
      state.isCurrentApprovalLoading = payload
    },
  },
})

export const { setPracticeId, setCurrentApproval, setCurrentApprovalLoading } =
  approvalSlice.actions

export const approvalReducer = approvalSlice.reducer

export const selectApproval = (state: ReduxRootState) => state.approval

export default approvalReducer
